import React,{useState,useRef,memo,useCallback,useEffect,useLayoutEffect} from 'react'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
import { openLink } from 'system/utils/linkHandler'
import history from 'system/navigation/MainRouterHistory'
import CharStyleOverrides from 'system/components/CharStyleOverrides'
// import {onErrorLoad} from 'system/AssetManager'

function TextComponent(props){
    
    
    const [inline,setInline] = useState({})
    const [text,setText] = useState(0)
    const [textCss, setTextCss] = useState({});
    const [resizeCount, setResizeCount] = useState(0)

    let bLoaded=false
    const refEle = useRef()
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})

    function onLoad(){
        // console.log('onLoad Text')
        if(!bLoaded){
            props.onLoad(props.index,refEle.current,props.model)
            bLoaded=true

            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }

         

        }
        
    }
    

    useEffect(()=>{
        refOrigOffset.current=refEle.current.offsetLeft
        if(refFormat.current && refFormat.current.animation && refFormat.current.animation.typeName){

            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation)

            console.log("inline text", refFormat.current.animation)

            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
        }

    },[inline]) // eslint-disable-line react-hooks/exhaustive-deps

    // Re-run font scaling on window resize (debounced so the Narrative
    // scroller and other layout handlers settle before we re-measure).
    const refResizeTimer = useRef(null);
    useEffect(() => {
        const onResize = () => {
            clearTimeout(refResizeTimer.current);
            refResizeTimer.current = setTimeout(() => setResizeCount(c => c + 1), 150);
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
            clearTimeout(refResizeTimer.current);
        };
    }, []);

    // Scale font sizes so text fills its container proportionally.
    // The CMS resizes the layer to exactly contain the text, so on the
    // front-end the text must scale to fill the container at any viewport size.
    // Strategy: use the container HEIGHT as the constraint (works for both
    // single-line and multi-line text). For multi-line text, scaling fonts
    // by S changes height by ~S² (line-height × S, line-count × S due to
    // re-wrapping), so the first pass uses sqrt(ratio) then refines.
    useLayoutEffect(() => {
        if (!refEle.current || !text) return;

        const container = refEle.current;
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        if (containerWidth <= 0 || containerHeight <= 0) return;

        const outerSpan = container.querySelector(':scope > span');
        if (!outerSpan) return;

        // Reset font sizes to original CMS values before measuring.
        // This is essential when re-running after resize so we compute
        // from the base values, not from previously-scaled values.
        if (textCss.fontSize) {
            outerSpan.style.fontSize = textCss.fontSize;
        }
        outerSpan.querySelectorAll('span[style]').forEach(span => {
            if (span.dataset.origFs) {
                span.style.fontSize = span.dataset.origFs;
            } else {
                const fs = parseFloat(span.style.fontSize);
                if (fs > 0) span.dataset.origFs = span.style.fontSize;
            }
        });

        // Ensure span is block-level so it wraps at container width
        outerSpan.style.display = 'block';
        outerSpan.style.width = '100%';

        const applyScale = (s) => {
            const fs = parseFloat(outerSpan.style.fontSize);
            if (fs > 0) outerSpan.style.fontSize = (fs * s) + 'px';
            outerSpan.querySelectorAll('span[style]').forEach(span => {
                const spanFs = parseFloat(span.style.fontSize);
                if (spanFs > 0) span.style.fontSize = (spanFs * s) + 'px';
            });
        };

        // Measure text height at CMS font sizes (wrapping within container)
        let textHeight = outerSpan.scrollHeight;
        if (textHeight <= 0) return;

        // Detect single-line: use width-based scaling when the text is
        // single-line content. Two checks:
        // 1. Container height fits ~1 line of the CMS font → designed as
        //    single-line, even if text currently wraps in a narrow container.
        // 2. Original check: text doesn't wrap at current width.
        const cmsFontSize = parseFloat(textCss.fontSize) || 0;
        const isSingleLine =
            (cmsFontSize > 0 && containerHeight < cmsFontSize * 1.5) ||
            (textHeight <= containerHeight * 1.1 &&
            (() => {
                const saved = outerSpan.style.whiteSpace;
                outerSpan.style.whiteSpace = 'nowrap';
                const h = outerSpan.scrollHeight;
                outerSpan.style.whiteSpace = saved;
                return Math.abs(h - textHeight) < 2;
            })());

        if (isSingleLine) {
            // Single-line: scale based on width (original approach)
            const savedWS = outerSpan.style.whiteSpace;
            const savedD = outerSpan.style.display;
            outerSpan.style.display = 'inline';
            outerSpan.style.whiteSpace = 'nowrap';
            const textWidth = outerSpan.getBoundingClientRect().width;
            outerSpan.style.display = savedD;
            outerSpan.style.whiteSpace = savedWS;

            if (textWidth <= 0) return;
            const scale = (containerWidth / textWidth) * 0.975;
            if (Math.abs(scale - 1) < 0.01) return;
            applyScale(scale);
        } else {
            // Multi-line: scale based on height with two-pass refinement.
            // Height scales as ~S² when font changes, so use sqrt for first pass.
            // Use a 2% safety margin on the target height to prevent overflow,
            // matching the single-line path's * 0.98 margin.
            let targetHeight = containerHeight * 0.975;
            let ratio = targetHeight / textHeight;
            if (Math.abs(ratio - 1) < 0.02) return;

            let scale = Math.sqrt(ratio);
            applyScale(scale);

            // Second pass: measure again after re-flow and fine-tune
            textHeight = outerSpan.scrollHeight;
            if (textHeight > 0) {
                ratio = targetHeight / textHeight;
                if (Math.abs(ratio - 1) > 0.02) {
                    applyScale(ratio);
                }
            }
        }
    }, [inline, text, textCss, resizeCount]);
    
    
    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        // console.log(refAnimationModel.current)
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // console.log('props.pageState', props.pageState)
        
        if (props.pageState === "animPage" && inline && refAnimationModel.current && refAnimationModel.current.animations) {
            // console.log('props.pageState', props.pageState)

            animateIntersect(refEle.current,refAnimationModel.current)
        }
    }, [props, inline])

    const onIntersect =  useCallback((evt,threshold)=>{
        
        // console.log('Text onINTERSECT', evt)
        // console.log('TEXT onIntersect', evt.detail.intersectionRatio, threshold)

        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
                animateIntersect(refEle.current,refAnimationModel.current)
              

        }
        else if(evt.detail.intersectionRatio <=0.001)
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
    },[refEle])

     const onAnim = useCallback((evt,threshold)=>{
        console.log('TEXT onAnim', evt)
        if(evt)
        {
            animateIntersect(refEle.current,refAnimationModel.current)

        }
        else {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
        }
            
    },[refEle])

    useEffect(() => {

        if (text && textCss && props) {
            onLoad()

            
        }
    }, [text, textCss, props])

    useEffect(()=>{

        
        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)

        console.log('refFormat', refFormat.current, props)
        
        let style ={position:'absolute',transform: 'translateZ(0), perspective: 1000px',willChange:'transform'}
        if(refFormat.current.style){ style = Object.assign(style,refFormat.current.style) }
        

        // console.log("seting ",getContentPath(f))

        // console.log("FORMAT", refFormat.current, props.model.formats,props.format)
        if (refFormat.current.html_text['text']) {
            setText(refFormat.current.html_text)
        }
        console.log('props.format', props.format)

        function translateCss(objCss) {
            let array = Object.entries(objCss);
            let reactCss = {};
            array.forEach((obj, i) => {
              switch (obj[0]) {
                case 'font-family':
                  reactCss['fontFamily'] = obj[1];
                  break;
                case 'font-weight':
                  reactCss['fontWeight'] = obj[1];
                  break;
                case 'font-size':
                  reactCss['fontSize'] = obj[1] + "px";
                  break;
                case 'text-align':
                  reactCss['textAlign'] = obj[1];
                  reactCss['display'] = 'block';
                  break;
                case 'color':
                  reactCss['color'] = obj[1];
                  break;
                case 'letter-spacing':
                    reactCss['letterSpacing'] = obj[1];
                    break;
                case 'line-height':
                    reactCss['lineHeight'] = obj[1];
                    break;
                default:
                  break;
              }
            })

            return reactCss
          }
            
        setTextCss( translateCss(refFormat.current.html_text['css']) )
        
        //set up animation Type
        if(refFormat.current.animation ){
            if(refFormat.current.animation.typeName==='parallax'){
                props.setScrollCallback(onScroll,props.index)
                style.willChange='transform'
            } 
            else if(refFormat.current.animation.typeName==='page'){
                props.onIntersect(onIntersect,props.index)
                props.onAnim(onAnim, props.index)
                style.willChange='transform, scale, opacity'
            }
        }
        setInline(style)
    
        
        return ()=>{}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props])

    function onError(evt){
        console.error("Text load error"+ bLoaded, evt.target.src)

        if(!bLoaded){
            onLoad() //dont hold up the page 
        }
    }

    function onClick() {
        console.log('props', props.model)
        let url = new URL(window.location.href)
        let pathLink = props.model.link;
        let urlparams= new URLSearchParams(pathLink)
       
        if (pathLink && url) {

            let isExternal = pathLink.includes('http') ||  pathLink.includes('https') ||  pathLink.includes('mailto');

            console.log('Globals.instance().useHashRouter', Globals.instance().useHashRouter, isExternal)

            if((Globals.instance().useHashRouter)&&(!isExternal))
            {
                let path = url.hash.substring(1)
                let arr=path.split('?')
                let search=''
                if(path.indexOf('?')){
                    path=arr[0]
                    search=arr[1]
                    
                }
                 search=search?'&'+pathLink:pathLink +"&landing=false"

                console.log(search,url.hash.substring(1)+'&'+pathLink)
                
                history.push({pathname:path,search:'?'+search})

            }else{

               
                if (isExternal) {
                    console.log('isExternal')
                    openLink(pathLink)

                } else {
                    console.log(url.pathname, pathLink)
                    history.push({pathname:url.pathname, search:'?'+pathLink}) 
                        
                }
                
                
            }
            
            let  moduleid=urlparams.get("module")
            
            if(moduleid){

                console.log(moduleid)
                refEle.current.dispatchEvent(new CustomEvent('narrative-pop-up', { detail:{typeName:"module",module:moduleid},bubbles:true}))
            }


        }
    }
    
  
    
    return ( 
            
        <div id={refFormat.current && "component_dim_file_" + refFormat.current.component} onClick={onClick} style={inline} onError={onError} ref={refEle} className={'force3d'} data-opacity={inline.opacity}>
            {text && <span style={textCss}><span dangerouslySetInnerHTML={{__html: CharStyleOverrides(text, props.format, null)}} /></span>}

            {console.log("props.format", props.format)}
        </div> 
    )

}

const TEXT = memo( TextComponent, (prev,next)=>{ 
    return false
})

export {TEXT}
